import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-036aa4b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" Do it all"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" hands-free. ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " LipSurf makes the web more productive, accessible, and convenient by letting you use your voice to dictate, click and navigate in the browser. ", -1))
const _hoisted_4 = { class: "mt-7" }
const _hoisted_5 = { class: "header-animation" }
const _hoisted_6 = { class: "d-flex flex-column justify-space-between" }
const _hoisted_7 = { class: "mt-3 attribution" }
const _hoisted_8 = { class: "mute" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", {
    title: "5 stars",
    style: {"width":"110px"},
    class: "multi star"
  })
], -1))
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = { class: "profile" }
const _hoisted_12 = ["srcset"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "faster-block-decor" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rel",
  style: {"z-index":"1"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "decor",
    style: {"width":"300px","text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "font-size-1" }, "Write Everything 3x Faster"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Spend less time typing by "),
      /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "dictating"),
      /*#__PURE__*/_createTextVNode(" instead. Works "),
      /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "anywhere"),
      /*#__PURE__*/_createTextVNode(" there's editable text. We use Google's cutting edge, mind-readingly accurate and blazingly fast AI enabled speech-to-text engine. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Oh, and say goodbye to typos 👋 ")
    ])
  ])
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigate-block-decor" }, null, -1))
const _hoisted_17 = {
  class: "rel",
  style: {"width":"300px","z-index":"1"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "decor",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-size-1" }, "Navigate Totally Hands-Free"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("If you've never experienced the ✨blissful magic of hands-free web browsing, you need to. "),
    /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "Click links, scroll articles, or watch videos"),
    /*#__PURE__*/_createTextVNode(" using simple voice commands. ")
  ])
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Works Where You Do"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Email, spreadsheets, documents, messaging apps, social media and "),
    /*#__PURE__*/_createElementVNode("b", null, "much more"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))
const _hoisted_21 = ["src", "title"]
const _hoisted_22 = { class: "mute" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ellipsis" }, " … ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figcaption", null, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "personalize-block-decor" }, null, -1))
const _hoisted_27 = {
  class: "rel",
  style: {"width":"300px","text-align":"left","z-index":"1"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "decor" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-size-1" }, "Personalize to Your Needs"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Map any word or phrase as a "),
    /*#__PURE__*/_createElementVNode("span", { class: "highlight alt" }, "voice shortcut"),
    /*#__PURE__*/_createTextVNode(" and quickly check the score of the game, insert a text template, customize it to understand workplace jargon, or much more. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, " The possibilities are limitless. ")
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["srcset"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "feature" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Prevent RSI/Carpal Tunnel Syndrome", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Taking breaks from the keyboard is the most effective way of "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "healing or preventing"),
  /*#__PURE__*/_createTextVNode(" office-related repetitive stress injuries. ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-5 font-italic font-light" }, [
    /*#__PURE__*/_createTextVNode(" “An ounce of prevention "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("is worth a pound of cure.” ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mute" }, "-Every therapist")
], -1))
const _hoisted_36 = [
  _hoisted_33,
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { class: "feature" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Multi-task", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You can 🍕 eat, 🧘 do yoga, 🧶 knit or even nurse your baby while you get work done. Having your hands free in front of your computer opens up countless (even strange) possibilities. ", -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = ["srcset"]
const _hoisted_42 = ["src"]
const _hoisted_43 = ["srcset"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "feature" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"1rem"} }, "No tracking, no ads, no selling your data", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We make money directly from subscriptions. Not by selling your data. ", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "It’s not Siri, Alexa or Google Home", -1))
const _hoisted_50 = {
  style: {"width":"300px","position":"relative"},
  class: "its-not"
}
const _hoisted_51 = ["srcset"]
const _hoisted_52 = ["src"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Siri, Alexa, and Google Home work great in a pinch for checking the weather or setting a timer - but they don't work for humanity's most important platform, the web. ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The web is the only truly ubiquitous, and open technology not controlled by any single gatekeeper. With the web already having the apps we use daily, and with voice being the next great computer interface (following the keyboard and mouse), we can have a more productive, accessible, and convenient life when both are combined. ", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Sometimes collaboration beats competition. We're collaborating with our beloved web to bring it supercharged productivity - letting you dictate and navigate anywhere on it with just your voice. ", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description d-flex flex-column justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { class: "description__head" }, "Open-Source Plugins"),
    /*#__PURE__*/_createElementVNode("p", null, " Make deep integrations. Everything is a plugin in LipSurf and anyone can make a plugin for LipSurf - it's fully extensible. ")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.lipsurf.com",
    class: "d-flex mt-5"
  }, "Developer Docs ›")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description d-flex flex-column justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { class: "description__head" }, "Multi-lingual"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("p", null, "🇺🇸 English"),
      /*#__PURE__*/_createElementVNode("p", null, "🇪🇸 Español Spanish"),
      /*#__PURE__*/_createElementVNode("p", null, "🇫🇷 Français French"),
      /*#__PURE__*/_createElementVNode("p", null, "🇷🇺 Русский Russian"),
      /*#__PURE__*/_createElementVNode("p", null, "🇯🇵 日本語 Japanese")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", { href: "https://help.lipsurf.com/configuration/adding-languages.html#adding-languages" }, "More Languages ›")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "description__head" }, "No special hardware required"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" No need to buy a Google Home or Alexa. LipSurf works with with your existing computer hardware and microphone "),
    /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "(Windows, Mac, Linux and even Chromebooks)"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_59 = { class: "info my-16" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skewed-block" }, null, -1))
const _hoisted_61 = { class: "info__content-block pa-5" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Is LipSurf right for me?", -1))
const _hoisted_63 = { class: "info-item" }
const _hoisted_64 = { class: "info-item__img d-flex justify-center align-center" }
const _hoisted_65 = ["src"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Motor Disabilities", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We make the web more accessible for people with Parkinson's, Arthritis, Cerebral Palsey, RSI, Carpal Tunnel Syndrome, Essential tremor, amputees and other motor disabilities. ", -1))
const _hoisted_68 = { class: "info-item" }
const _hoisted_69 = { class: "info-item__img pa-3 d-flex justify-center align-center" }
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Productivity Nerds", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Want to write 3x faster than you type? ❤️ shortcuts? Want to control the computer without reaching to the keyboard? ", -1))
const _hoisted_73 = { class: "info-item" }
const _hoisted_74 = { class: "info-item__img pa-3 d-flex justify-center align-center" }
const _hoisted_75 = ["src"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Computer Professionals", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Office workers, teachers, executives, project managers, bloggers, and other professionals who need to type every day. ", -1))
const _hoisted_78 = { class: "info-item" }
const _hoisted_79 = { class: "info-item__img pa-3 d-flex justify-center align-center" }
const _hoisted_80 = ["src"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Neurodiverse", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " People with Dyslexia and/or ADHD. ", -1))
const _hoisted_83 = { class: "center mt-16" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "font-regular",
    style: {"font-size":"1.1rem"}
  }, "LipSurf works through Google Chrome."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.1rem"} }, [
    /*#__PURE__*/_createTextVNode("Simply add it and you’ll be using voice-commands "),
    /*#__PURE__*/_createElementVNode("strong", null, "30 seconds"),
    /*#__PURE__*/_createTextVNode(" from now.")
  ])
], -1))
const _hoisted_85 = ["srcset"]
const _hoisted_86 = ["src"]

import BaseLayout from './BaseLayout.vue';
import InlineVideo from '@/components/InlineVideo.vue';
import HeaderAnim from '../components/HeaderAnim.vue';
import InstallBtn from '../components/InstallBtn.vue';
import rawAnimData from '../assets/anim/girl.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'Landing',
  setup(__props) {

const testimonials = [
  [
    "I had LipSurf up and running... within 5 - 10 minutes. It is amazing. It works in the Chrome browser... and Dragon never did.",
    "Jessica DeVita",
    "Jessica",
  ],
  [
    "Couldn't be happier right now - I've been looking for something like this for ages!",
    "Steve Whitehead",
    "Steve",
  ],
  [
    "[I]t has been absolutely life-changing as I am dyslexic it helped me a great deal and with the support I have received has been amazing!",
    "Shea Conrad",
    "Shea",
  ],
];
const apps = [
  'gmail',
  'outlook',
  'google_docs',
  'google_sheets',
  'facebook',
  'linkedin',
  'microsoft_word',
  'youtube',
  'reddit',
  'slack',
  'twitter',
  'discord',
  'whatsapp',
  'evernote',
  'salesforce'
];

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _directive_animate_onscroll = _resolveDirective("animate-onscroll")!

  return (_openBlock(), _createBlock(BaseLayout, null, {
    outer: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                "align-self": "center",
                cols: "12",
                md: "5",
                class: "action-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(InstallBtn, { width: "100%" })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "7",
                class: "anim-wrap"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(HeaderAnim, {
                      name: "girl",
                      alt: "A young woman sits at her desk as she speaks commands to her computer. The computer reacts according to her voice commands, e.g. when she says \"down\" the screen is shown scrolling down. A pleased cat is resting on her keyboard throughout.",
                      "raw-anim-data": _unref(rawAnimData)
                    }, null, 8, ["raw-anim-data"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, {
        class: "testimonials",
        style: {"max-width":"1500px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            justify: "center",
            class: "mx-8"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(testimonials, (testimonial) => {
                return _createVNode(_component_v_col, {
                  md: "4",
                  cols: "12",
                  class: "d-flex justify-center",
                  key: testimonial[1]
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", null, _toDisplayString(testimonial[0]), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(testimonial[1]), 1),
                          _hoisted_9
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, [
                            _createElementVNode("picture", null, [
                              _createElementVNode("source", {
                                type: "image/avif",
                                srcset: require(`@/assets/img/${testimonial[2]}.jpg?width=60&height=60&format=avif`)
                              }, null, 8, _hoisted_12),
                              _createElementVNode("img", {
                                src: require(`@/assets/img/${testimonial[2]}.jpg?width=60&height=60`),
                                width: "60",
                                height: "60",
                                alt: `photo of ${testimonial[2]}`,
                                class: "circular-photo"
                              }, null, 8, _hoisted_13)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "my-10" })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, {
        fluid: "",
        class: "my-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            row: "",
            wrap: "",
            class: "screen-height",
            justify: "center",
            align: "center"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                sm: "12",
                md: "4",
                class: "rel"
              }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _createVNode(_component_v_row, {
                    column: "",
                    justify: "center",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex justify-center align-center" }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_animate_onscroll, {down: 'slideInLeft'}]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                sm: "12",
                md: "8",
                "align-self": "center",
                "fill-height": "",
                style: {"z-index":"1"},
                class: "rel"
              }, {
                default: _withCtx(() => [
                  _createVNode(InlineVideo, {
                    name: "office",
                    alt: "User is saying a phrase and it's being transcribed into a Google Docs document."
                  })
                ]),
                _: 1
              })), [
                [_directive_animate_onscroll, {down: 'slideInRight'}]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, {
        fluid: "",
        class: "my-16"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            column: "",
            wrap: "",
            class: "screen-height",
            justify: "center",
            align: "center"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                sm: "12",
                md: "8",
                class: "d-flex justify-end rel",
                style: {"z-index":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(InlineVideo, {
                    name: "leisure",
                    alt: "User is navigating YouTube. Their spoken commands are displayed at the top of the screen as they search for a video, pause it, subscribe to the channel and like the video all using LipSurf voice commands."
                  })
                ]),
                _: 1
              })), [
                [_directive_animate_onscroll, {down: 'slideInLeft'}]
              ]),
              _createVNode(_component_v_col, {
                sm: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "justify-center": "",
                    "align-center": "",
                    "fill-height": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex justify-center rel" }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)), [
                            [_directive_animate_onscroll, {down: 'slideInRight'}]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, {
        fluid: "",
        class: "my-16"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_v_row, {
            column: "",
            "align-content-center": "",
            "justify-center": "",
            "align-center": "",
            "fill-height": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                align: "center",
                style: {"max-width":"800px","margin":"0 auto"}
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _: 1
          })), [
            [_directive_animate_onscroll, {down: 'fadeIn'}]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_v_row, {
            justify: "center",
            class: "works-where mt-6"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(apps, (app, i) => {
                return _withDirectives(_createElementVNode("figure", { key: app }, [
                  _createElementVNode("img", {
                    src: require(`@/assets/img/${app}.svg`),
                    class: "ma-5",
                    width: "50",
                    height: "50",
                    title: `${app} logo`
                  }, null, 8, _hoisted_21),
                  _createElementVNode("figcaption", _hoisted_22, _toDisplayString(app.toUpperCase().replace(/_/g, ' ')), 1)
                ]), [
                  [_directive_animate_onscroll, {down: 'slideInRight', delay: i * 60}]
                ])
              }), 64)),
              _withDirectives((_openBlock(), _createElementBlock("figure", null, _hoisted_25)), [
                [_directive_animate_onscroll, {down: 'slideInRight', delay: apps.length * 100}]
              ])
            ]),
            _: 1
          })), [
            [_directive_animate_onscroll, {down: 'fadeIn'}]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            row: "",
            wrap: "",
            class: "screen-height",
            justify: "center",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                sm: "12",
                md: "4",
                "align-self-center": "",
                "fill-height": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    column: "",
                    "align-content-center": "",
                    "justify-center": "",
                    "align-center": "",
                    "fill-height": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex justify-center",
                        style: {"position":"relative"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29)), [
                            [_directive_animate_onscroll, {down: 'slideInLeft'}]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                sm: "12",
                md: "8",
                "align-self-center": "",
                class: "d-flex justify-start rel",
                style: {"z-index":"1"}
              }, {
                default: _withCtx(() => [
                  _createVNode(InlineVideo, {
                    name: "shortcuts",
                    alt: "User is adding a shortcut to LipSurf. They make it so anytime they say \"calendar\" LipSurf goes to the URL where their calendar lives."
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, { class: "d-flex justify-center align-center flex-column mt-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            row: "",
            wrap: "",
            class: "ma-16"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                sm: "12",
                md: "6",
                "align-self-center": "",
                "fill-height": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_v_row, {
                    column: "",
                    "align-content-center": "",
                    "justify-center": "",
                    "align-center": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("picture", null, [
                              _createElementVNode("source", {
                                type: "image/webp",
                                srcset: require(`@/assets/img/hands.png?width=233&height=179&format=webp`)
                              }, null, 8, _hoisted_30),
                              _createElementVNode("img", {
                                src: require(`@/assets/img/hands.png?width=233&height=179`),
                                width: "233",
                                alt: "hands in pain",
                                height: "179",
                                loading: "lazy"
                              }, null, 8, _hoisted_31)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_animate_onscroll, {down: 'slideInLeft'}]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                sm: "12",
                md: "6",
                "align-self-center": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_36)), [
                    [_directive_animate_onscroll, {down: 'slideInRight'}]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            row: "",
            wrap: "",
            class: "ma-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                sm: "12",
                md: "6",
                "align-self-center": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_40)), [
                    [_directive_animate_onscroll, {down: 'slideInLeft'}]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                sm: "12",
                md: "6",
                "align-self-center": "",
                "fill-height": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    column: "",
                    "align-content-center": "",
                    "justify-center": "",
                    "align-center": ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_v_col, { class: "d-flex justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("picture", null, [
                              _createElementVNode("source", {
                                type: "image/webp",
                                srcset: require(`@/assets/img/yoga-cat.png?width=271&height=311&format=webp`)
                              }, null, 8, _hoisted_41),
                              _createElementVNode("img", {
                                src: require(`@/assets/img/yoga-cat.png?width=271&height=311`),
                                alt: "cat doing yoga in front of a laptop",
                                width: "271",
                                height: "311",
                                loading: "lazy"
                              }, null, 8, _hoisted_42)
                            ])
                          ])
                        ]),
                        _: 1
                      })), [
                        [_directive_animate_onscroll, {down: 'slideInRight'}]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            row: "",
            wrap: "",
            class: "ma-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                sm: "12",
                md: "6",
                "align-self-center": "",
                "fill-height": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    column: "",
                    "align-content-center": "",
                    "justify-center": "",
                    "align-center": ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_v_col, { class: "d-flex justify-center align-center" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("picture", null, [
                              _createElementVNode("source", {
                                type: "image/webp",
                                srcset: require(`@/assets/img/data-cat.png?width=241&height=369&format=webp`)
                              }, null, 8, _hoisted_43),
                              _createElementVNode("img", {
                                src: require(`@/assets/img/data-cat.png?width=241&height=369`),
                                width: "241",
                                alt: "cat with sunglasses on a sketchy streetcorner opening a cloak that says \"user data\" inside",
                                height: "369",
                                loading: "lazy"
                              }, null, 8, _hoisted_44)
                            ])
                          ])
                        ]),
                        _: 1
                      })), [
                        [_directive_animate_onscroll, {down: 'slideInLeft'}]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                sm: "12",
                md: "6",
                "align-self-center": "",
                class: "d-flex justify-center align-center"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_48)), [
                    [_directive_animate_onscroll, {down: 'slideInRight'}]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_divider, { class: "my-2" })
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, { class: "d-flex justify-center flex-column align-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                xs12: "",
                md12: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_v_row, {
              justify: "center",
              align: "start"
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                  xs12: "",
                  md6: "",
                  class: "d-flex justify-center align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("picture", null, [
                        _createElementVNode("source", {
                          type: "image/webp",
                          srcset: require(`@/assets/img/surfboards.png?width=300&height=685&format=webp`)
                        }, null, 8, _hoisted_51),
                        _createElementVNode("img", {
                          src: require(`@/assets/img/surfboards.png?width=300&height=685`),
                          height: "685",
                          width: "300",
                          loading: "lazy",
                          alt: "surfboards",
                          style: {"position":"absolute","z-index":"0","left":"-320px","bottom":"0px"}
                        }, null, 8, _hoisted_52)
                      ]),
                      _hoisted_53,
                      _hoisted_54,
                      _hoisted_55
                    ])
                  ]),
                  _: 1
                })), [
                  [_directive_animate_onscroll, {down: 'fadeIn'}]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_divider, { class: "my-16" }),
          _createVNode(_component_v_row, {
            align: "center",
            "justify-content": "center"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                justify: "center",
                md: "4",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_56
                ]),
                _: 1
              })), [
                [_directive_animate_onscroll, {down: 'slideInLeft'}]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                justify: "center",
                md: "4",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_57
                ]),
                _: 1
              })), [
                [_directive_animate_onscroll, {down: 'fadeIn'}]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                justify: "center",
                md: "4",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _hoisted_58
                ]),
                _: 1
              })), [
                [_directive_animate_onscroll, {down: 'slideInRight'}]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createVNode(_component_v_row, {
              justify: "center",
              align: "start",
              wrap: "",
              row: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  sm12: "",
                  md6: "",
                  class: "d-flex justify-center flex-column align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/wheelchair-woman.png'),
                          width: "100",
                          height: "91",
                          alt: "woman in a wheelchair",
                          loading: "lazy"
                        }, null, 8, _hoisted_65)
                      ]),
                      _hoisted_66,
                      _hoisted_67
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  sm12: "",
                  md6: "",
                  class: "d-flex justify-center flex-column align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/santa.png'),
                          width: "100",
                          height: "91",
                          alt: "wizard",
                          loading: "lazy"
                        }, null, 8, _hoisted_70)
                      ]),
                      _hoisted_71,
                      _hoisted_72
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  sm12: "",
                  md6: "",
                  class: "d-flex justify-center flex-column align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/programmer.png'),
                          width: "100",
                          height: "91",
                          alt: "person on a laptop",
                          loading: "lazy"
                        }, null, 8, _hoisted_75)
                      ]),
                      _hoisted_76,
                      _hoisted_77
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  sm12: "",
                  md6: "",
                  class: "d-flex justify-center flex-column align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/brain.png'),
                          width: "100",
                          height: "91",
                          alt: "brain",
                          loading: "lazy"
                        }, null, 8, _hoisted_80)
                      ]),
                      _hoisted_81,
                      _hoisted_82
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])), [
          [_directive_animate_onscroll, {down: 'fadeIn'}]
        ])
      ]),
      _createElementVNode("section", _hoisted_83, [
        _hoisted_84,
        _createElementVNode("div", null, [
          _createVNode(InstallBtn)
        ]),
        _createElementVNode("picture", null, [
          _createElementVNode("source", {
            type: "image/webp",
            srcset: require(`@/assets/img/kb-cat-2.png?width=201&height=131&format=webp`)
          }, null, 8, _hoisted_85),
          _createElementVNode("img", {
            src: require(`@/assets/img/kb-cat-2.png?width=201&height=131`),
            width: "201",
            height: "131",
            loading: "lazy",
            alt: "cat cleaning self on keyboard",
            "aria-role": "presentation",
            class: "mt-6"
          }, null, 8, _hoisted_86)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})